import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import StepNavigator from 'Components/ComponentLibrary/Molecules/StepNavigator';
import { Stack } from '@facet-wealth/design';
import { makeStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useHistory } from 'react-router-dom';
import Box from '../../../../../Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { metaOverrideSet } from './metaOverride';
import Content from './Content';


const useStyles = makeStyles(theme => ({
  stepNavigator: {
    position: 'sticky',
    zIndex: 100,
    bottom: 0,
  },
  form: {
    flexGrow: 1,
    backgroundColor: theme.palette.facet.lightGray,
  },
}));

const CapitalizeRolloverAccountsStatusStepTemplate = ({ resource }) => {
  const { setPageContentCollection, isPageContentLoading, loadPageContentLink } = usePageContentContext();
  const history = useHistory();
  const theme = useTheme();
  const classes = useStyles(theme);
  const [loading, setLoading] = React.useState(false);
  const [errors, setErrors] = React.useState([]);

  const onClose = async () => {
    resource.withRelationship(fr.relationships.previousLink.name,
      () => {
        loadPageContentLink(resource.relationship(fr.relationships.previousLink.name).link('related'));
      },
      () => {
        resource.withRelationship(fr.relationships.redirectOnClose.name,
          () => {
            loadPageContentLink(resource.relationship(fr.relationships.redirectOnClose.name).link('related'));
          },
          () => {
            history.push('/');
          });
      });
  };

  const handleNext = async () => {
    setLoading(true);
    setErrors([]);
    try {
      const updatedColl = await resource.submit();
      await setPageContentCollection(updatedColl);
    } catch (e) {
      setLoading(false);
      setErrors(e.errors);
    }
    setLoading(false);
  };

  return (
    <Stack direction={'column'} minHeight={'100dvh'}>
      <MetaFormInline
        className={classes.form}
        noIndividualSubmitButtons
        resource={resource}
        layout={Content}
        LayoutProps={{ errors }}
        metaOverrideSet={metaOverrideSet}
      />
      <Box className={classes.stepNavigator}>
        <StepNavigator
          disabled={isPageContentLoading || loading}
          isLoading={isPageContentLoading || loading}
          onNext={handleNext}
          onPrevious={onClose}
        >
          {resource.attr('primaryActionLabel') || 'Continue'}
        </StepNavigator>
      </Box>
    </Stack>
  );
};

CapitalizeRolloverAccountsStatusStepTemplate.defaultProps = {
};

CapitalizeRolloverAccountsStatusStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default CapitalizeRolloverAccountsStatusStepTemplate;
